'use client'

import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { initPosthog, posthog } from '@package/analytics/client'

import { env } from '~/env'

/**
 * Boots posthog-js once and emits a $pageview on every client navigation.
 * We disable the SDK's built-in pageview capture and fire manually on pathname
 * change so Next's app-router client transitions are tracked reliably.
 */
export function PostHogProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname()

  console.table({
    NEXT_PUBLIC_POSTHOG_KEY: env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_POSTHOG_UI_HOST: env.NEXT_PUBLIC_POSTHOG_UI_HOST,
  })

  useEffect(() => {
    initPosthog({
      key: env.NEXT_PUBLIC_POSTHOG_KEY,
      host: env.NEXT_PUBLIC_POSTHOG_HOST,
      uiHost: env.NEXT_PUBLIC_POSTHOG_UI_HOST,
      capturePageview: false,
      // Visitors are anonymous here, so an exception could not be tied to a person; Sentry has it.
      captureExceptions: false,
    })
  }, [])

  useEffect(() => {
    if (pathname) posthog.capture('$pageview')
  }, [pathname])

  return <>{children}</>
}
